import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ManagedLoginService } from 'src/app/services/managed-login.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  authState: boolean = false;
  isAuthenticated(): boolean {
    // const idToken = localStorage.getItem('id_token')
    // const refreshToken = localStorage.getItem('refresh_token')
    // return !!(idToken && refreshToken)
    try {
      const idToken = localStorage.getItem('id_token');
      const refreshToken = localStorage.getItem('refresh_token');

      // Check if tokens exist
      if (!idToken || !refreshToken) {
        return false;
      }

      // Optional: Add token expiration check here
      // const tokenPayload = this.parseJwt(idToken)
      // const currentTime = Date.now() / 1000
      // return tokenPayload.exp > currentTime

      return true;
    } catch (error) {
      console.error('Error checking authentication:', error);
      return false;
    }
  }
}

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authService = inject(PermissionsService);
  const managedLoginService = inject(ManagedLoginService);
  const router = inject(Router);

  const isAuthenticated = authService.isAuthenticated();

  console.log({
    isAuthenticated,
    route: state.url,
    tokens: {
      id_token: !!localStorage.getItem('id_token'),
      refresh_token: !!localStorage.getItem('refresh_token'),
    },
  });

  if (isAuthenticated) {
    return true;
  } else {
    // Store the attempted URL for redirect after login
    localStorage.setItem('redirectUrl', state.url);
    managedLoginService.signIn();
    return false;
  }

  // const authService = inject(PermissionsService)
  // const managedLoginService = inject(ManagedLoginService)
  // const isAuthenticated = authService.isAuthenticated()

  // console.log({
  //   isAuthenticated,
  //   next,
  //   state
  // })

  // if (isAuthenticated) {
  //   return true
  // } else {
  //   // Store the attempted URL for redirect after login
  //   window.localStorage.setItem('redirectUrl', state.url)
  //   managedLoginService.signIn()
  //   return false
  // }
};
